import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { getCookie, setCookie } from '../Util/Cookie';
import { useSpring, animated } from 'react-spring';


export default function CookieConsent(props) {
    const [consent, setConsent] = useState(true);
    const classes = useStyles();
    const [guiLanguage, setGuiLanguage] = useState('en');
    const fade = useSpring({
        config: { duration: 1000 },
        from: {
            bottom: '-160px',
        },
        to: {
            bottom: '0px',
        }
    })

    useEffect(
        () => {
            if (window.location.href.indexOf('lang=tr') > 0) {
                setGuiLanguage('tr');
            }
        }, []
    )

    useEffect(
        () => {
            if (getCookie('ht_cookieConsent_admin') == null) {
                setConsent(false);
            }
            else {
                setConsent(true);
            }
        }, []
    )

    const consentGiven = () => {
        setCookie('ht_cookieConsent_admin', 'true', 700);
        setConsent(true);
    }


    return (
        <React.Fragment>
            {consent == false ?
                <animated.div style={fade} className={classes.root}>
                    <div className={classes.closeButtonWrapper}>
                        <i className="material-icons" onClick={consentGiven}>
                            close
                        </i>
                    </div>
                    <div>
                        {
                            guiLanguage == 'tr' ?
                            <span>
                                Web uygulamamızda size en iyi deneyimi yaşatabilmek için çerezlerden faydalanıyoruz.
                                Uygulamayı kullanmaya devam ederek çerez kullanımına onay vermiş oluyorsunuz.
                                Daha fazla detay için lütfen <a href="https://happytable.app/privacy-policy.html">Gizlilik Politikamızı</a> okuyun.
                            </span>
                            :
                            <span>
                                We use cookies to give you the best possible experience on our web app.
                                By continuing to browse or use this web app, you give consent for cookies to be used.
                                For more details, please read our <a href="https://happytable.app/privacy-policy.html">Privacy Policy</a>
                            </span>
                        }
                        
                    </div>
                </animated.div>
                : null
            }
        </React.Fragment>
    )
}

const useStyles = makeStyles({
    root: {
        position: 'fixed',
        padding: '0 10px 30px 10px',
        backgroundColor: '#3b4045',
        color: 'white',
        fontSize: '0.9rem',
        zIndex: 101,
        width: '100%',
        //transition: '1s',
        //bottom: '-160px',
    },
    noConsent: {
        bottom: '0px',
    },
    yesConsent: {
        bottom: '-160px',
    },
    closeButtonWrapper: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: '0 15px',
    },
});